export default {
  app: {
    terminal: "企业业务端",
    description: "仓储管理系统",
    tagline: "从企业注册、货物申报到收货入库，全程可查",
  },
  common: {
    loading: "正在加载…",
    retry: "重试",
    save: "保存",
    submit: "提交",
    cancel: "取消",
    close: "关闭",
    edit: "编辑",
    delete: "删除",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    search: "搜索",
    all: "全部",
    pending: "待处理",
    completed: "已完成",
    error: "操作未完成，请检查后重试",
    required: "此项为必填项",
    noData: "暂时没有记录",
    savedDraft: "草稿已自动保存",
    leaveWarning: "当前内容尚未提交，确定离开吗？",
    upload: "选择文件",
    remove: "移除",
    previousOption: "上一项",
    nextOption: "下一项",
    qrCode: "二维码",
    skip: "跳到主要内容",
    backHome: "返回首页",
  },
  nav: {
    home: "首页",
    declarations: "申报单",
    payment: "付款",
    receiving: "收货",
    receivingOrders: "收货单",
    work: "作业",
    selfOperation: "仓储自营",
    received: "已收",
    profile: "我的",
    logout: "退出登录",
    homeMarker: "首",
    declarationsMarker: "申",
    paymentMarker: "付",
    receivingMarker: "收",
    profileMarker: "我",
  },
  selfOperation: {
    home: {
      eyebrow: "SELF OPERATION",
      title: "仓储自营",
      lead: "在您租赁的专属储区内自助完成入库与出库。",
      overdueBanner: "当前合同存在逾期未结清账单，暂不能新增入库；请先结清并由出租方确认到账。出库取货不受影响。",
      contractTitle: "我的租赁合同",
      validUntil: "有效期至",
      areas: "合同储区",
      entries: "快捷入口",
      inventory: "库存查询",
      stockIn: "自营入库",
      stockOut: "自营出库",
      empty: "暂无可自营的合同",
    },
    inventory: {
      title: "我的库存",
      keywordPlaceholder: "搜索商品名称/编码",
      empty: "合同储区内暂无库存",
      available: "可用",
      onHand: "在手",
      frozen: "冻结",
      batch: "批次",
    },
    common: {
      status: "状态",
      version: "版本",
      submit: "提交",
      cancel: "取消单据",
      cancelReasonPlaceholder: "取消原因（可选）",
      cancelConfirm: "确认取消该单据？",
      remark: "备注",
      empty: "暂无单据",
      loadMore: "加载更多",
      quantity: "数量",
      location: "储位",
      product: "商品",
      statusPendingPutaway: "待上架",
      statusPartiallyPutaway: "部分上架",
      statusPutawayCompleted: "已上架",
      statusPendingPick: "待拣货",
      statusPartiallyPicked: "部分拣货",
      statusPickedCompleted: "已拣货",
      statusCancelled: "已取消",
      overdueBlockedCopy: "该合同存在逾期未结清账单，暂不能新增入库；请先结清并由出租方确认到账",
    },
    stockIn: {
      listTitle: "自营入库单",
      createTitle: "新建入库单",
      detailTitle: "入库单详情",
      addLine: "添加商品",
      batchNoPlaceholder: "批次号（可选）",
      createSubmit: "创建入库单",
      createSuccess: "入库单已创建",
      putaway: "上架",
      putawayTitle: "执行上架",
      addAllocation: "添加上架分配",
      allocationQuantity: "上架数量",
      putawaySubmit: "提交上架",
      putawaySuccess: "上架成功",
      progress: "上架进度",
      declaredQuantity: "申报数量",
      putawayQuantity: "已上架",
    },
    stockOut: {
      listTitle: "自营出库单",
      createTitle: "新建出库单",
      detailTitle: "出库单详情",
      addLine: "添加商品",
      availableHint: "可用",
      createSubmit: "创建出库单",
      createSuccess: "出库单已创建",
      pick: "拣货",
      pickTitle: "执行拣货",
      addAllocation: "添加拣货分配",
      pickSubmit: "提交拣货",
      pickSuccess: "拣货成功",
      progress: "拣货进度",
      requestedQuantity: "请求数量",
      pickedQuantity: "已拣货",
      pickCandidateEmpty: "该商品暂无可拣库存",
    },
  },
  work: {
    eyebrow: "WAREHOUSE WORK",
    title: "仓库任务中心",
    lead: "查看分配给我的任务，或从开放任务池领取作业。",
    bucketLabel: "任务范围",
    bucket: { mine: "我的", claimable: "可领取", completed: "已完成" },
    taskTypeLabel: "任务类型",
    warehouseLabel: "仓库",
    allWarehouses: "全部仓库",
    searchLabel: "搜索仓库任务",
    searchPlaceholder: "任务号 / 仓库编码 / 仓库名称",
    assigneeLabel: "执行人",
    unassigned: "待领取",
    completedAt: "完成时间",
    claim: "领取任务",
    release: "释放任务",
    loadMore: "加载更多",
    releaseTitle: "释放任务",
    releaseLead: "任务 {no} 将返回开放任务池，请填写交接原因。",
    releaseReason: "释放原因",
    releaseReasonPlaceholder: "例如：换班交接、设备不可用",
    confirmRelease: "确认释放",
    claimed: "任务已领取，可在“我的”中查看。",
    released: "任务已释放，可在“可领取”中查看。",
    conflict: "任务状态已变化，列表已刷新，请确认最新状态。",
    permissionChanged: "仓库权限已变化，当前任务已不可操作。",
    commandFailed: "操作未完成，请检查网络后重试。",
    scan: { camera: "扫码识别", image: "选择条码图片", resolve: "识别", failed: "未识别到有效编码，请改用图片或手工输入。" },
    putaway: {
      title: "入库上架", continue: "继续上架", scanCamera: "扫码识别",
      scanImage: "选择条码图片", resolve: "识别", scanFailed: "未识别到有效编码，请改用图片或手工输入。",
      linesTitle: "待上架商品", multipleProducts: "扫码匹配到多条商品明细，请选择本次上架行。",
      progress: "已上架 {putaway} / 实收 {received} {unit}", remaining: "待上架 {quantity} {unit}",
      selectProduct: "选择{product}", editorTitle: "新增上架拆分", selectLineFirst: "请先选择待上架商品。",
      batchMode: "批次处理", batchInternal: "系统内部批次", batchExisting: "选择已有批次", batchNamed: "创建命名批次",
      batchScanLabel: "批号或条码", existingBatch: "已有批次", selectBatch: "请选择批次", newBatchNo: "新批号",
      locationScanLabel: "库位编码或条码", locationFact: "库位：{code}", quantityLabel: "上架数量（{unit}）",
      addDraft: "加入上架清单", draftTitle: "上架清单", draftErrors: "上架清单需要修正",
      batchFact: "批次：{batch}", itemQuantity: "{product} 上架数量", updateItem: "更新{product}", removeItem: "移除{product}",
      error: {
        line_unavailable: "商品行已不可上架", quantity_invalid: "数量格式或精度无效",
        quantity_exceeds_remaining: "上架数量超过服务端最新待上架数量",
      },
      eyebrow: "PUTAWAY EXECUTION", warehouseFallback: "当前任务仓库", detailFailed: "入库任务加载失败。",
      lookupFailed: "未能识别该编码，请核对后重试。", submitFailed: "上架提交失败，请稍后重试。",
      completed: "本入库任务已完成上架。", scanProductTitle: "识别待上架商品", productScanLabel: "商品编码或条码",
      submit: "提交上架", submitted: "本次上架已提交，服务端最新进度已刷新。", retrySubmit: "重试原提交", abandonIntent: "放弃原提交并编辑",
      retryFrozen: "网络未确认提交结果。只能重试原提交，或放弃后重新编辑。",
      validationFailed: "上架内容未通过校验，请修正草稿后重新提交。",
      conflict: "任务版本已变化，已刷新服务端最新事实。请检查标记项，不会自动重提。",
      permissionChanged: "仓库授权已变化，当前任务已关闭。", unavailableNotice: "该仓库任务已不可用。",
      leaveWarning: "当前上架草稿或待重试提交尚未处理，确定离开吗？",
    },
    picking: {
      title: "出库拣货", continue: "继续拣货", linesTitle: "待拣商品",
      progress: "已拣 {picked} / 请求 {requested} {unit}", remaining: "待拣 {quantity} {unit}",
      selectProduct: "选择{product}", candidatesTitle: "可拣库存候选", noCandidates: "没有匹配的可拣库存，请核对扫码值或库存状态。",
      batchFact: "批次：{batch}", locationFact: "库位：{code}", available: "可用 {quantity} {unit}",
      candidateQuantity: "{product} 在 {location} 的拣货数量", addDraft: "加入拣货清单", loadMore: "加载更多库存候选",
      draftTitle: "拣货清单", draftErrors: "拣货清单需要修正", itemQuantity: "{product} 拣货数量",
      updateItem: "更新{product}", removeItem: "移除{product}",
      error: {
        line_unavailable: "商品行已不可拣货", candidate_unavailable: "库存候选已不可用",
        quantity_invalid: "数量格式或精度无效", quantity_exceeds_remaining: "超过出库行最新待拣数量",
        quantity_exceeds_available: "超过候选实时可用量",
      },
      eyebrow: "PICKING EXECUTION", warehouseFallback: "当前任务仓库", detailFailed: "出库任务加载失败。",
      scanTitle: "筛选可拣库存", scanLabel: "商品、批次或库位编码", candidateFailed: "可拣库存加载失败，请稍后重试。",
      selectLineFirst: "请先选择待拣商品。", submitFailed: "拣货提交失败，请稍后重试。",
      completed: "本出库任务已完成拣货。", submit: "提交拣货", submitted: "本次拣货已提交，服务端最新进度已刷新。",
      retrySubmit: "重试原提交", abandonIntent: "放弃原提交并编辑",
      retryFrozen: "网络未确认提交结果。只能重试原提交，或放弃后重新编辑。",
      validationFailed: "拣货内容未通过校验，请修正草稿后重新提交。",
      conflict: "任务版本已变化，已刷新服务端最新事实。请检查标记项，不会自动重提。",
      permissionChanged: "仓库授权已变化，当前任务已关闭。", unavailableNotice: "该仓库任务已不可用。",
      leaveWarning: "当前拣货草稿或待重试提交尚未处理，确定离开吗？",
    },
    stockTake: {
      title: "仓库盘点", continue: "继续盘点", eyebrow: "BLIND COUNT EXECUTION",
      stepLocation: "01 · 库位锚定", locationTitle: "扫描当前库位", changeLocation: "更换库位",
      locationScanLabel: "库位编码或条码", locationScanPlaceholder: "扫描或输入库位编码",
      locationProgress: "本库位已录 {recorded} / {total}", locationFailed: "未在当前盘点任务中找到该库位。",
      stepLine: "02 · 商品 / 批次定位", lineTitle: "定位盘点明细", damagedLabel: "标签损坏？查看未盘清单",
      anchorFirst: "请先扫描并确认当前库位。", lineScanLabel: "商品编码、条码或批次号",
      lineScanPlaceholder: "精确扫描商品或批次", ambiguous: "匹配到 {count} 条明细，请按批次选择。",
      noLines: "当前库位没有匹配的盘点明细。", linesFailed: "盘点明细加载失败，请稍后重试。",
      batchFact: "批次：{batch}", recorded: "已录", unrecorded: "未录",
      stepCount: "03 · 实盘录入", editorTitle: "录入实盘数量", selectLineFirst: "请先扫描或选择一条盘点明细。",
      locationLabel: "库位", batchLabel: "批次", quantityLabel: "实盘数量（{unit}）",
      rerecord: "已录 {quantity} {unit}；本次保存将覆盖原实盘值。", saveLine: "保存本行", saveAgain: "覆盖重录",
      zeroWarning: "确认该批次实物数量为 0？空输入不会被视为零。", confirmZero: "确认记为 0",
      quantityError: { blank: "请输入实盘数量，空值不等于零。", format: "请输入非负数字。", precision: "数量小数位超过该单位精度。" },
      detailFailed: "盘点任务加载失败。", saveFailed: "本行实盘未能保存，请稍后重试。",
      saved: "本行实盘已保存。", validationFailed: "实盘数量未通过校验，输入已保留。",
      conflict: "任务版本已变化，已刷新并核对服务端实盘；不会自动重提。",
      unknownResult: "网络未确认保存结果。请刷新并核对，系统不会自动重发。",
      refreshAndCheck: "刷新并核对", reconciled: "已核对：服务端已保存相同实盘值。",
      unconfirmed: "已刷新，未确认服务端保存成功；请核对输入后手动再次保存。",
      leaveWarning: "当前实盘输入或待核对结果尚未处理，切换或离开后将丢失。确定继续吗？",
      permissionChanged: "仓库授权已变化，当前盘点录入已关闭。", unavailableNotice: "该盘点任务已不可用。",
      reviewTitle: "录盘完成，等待 Owner / 主管复核", reviewLead: "H5 不展示账面库存或差异；请由 Owner 或仓库主管在管理端复核。",
      closed: "该盘点任务已完成或取消，录入已关闭。",
    },
    type: { stock_in: "入库", stock_out: "出库", stock_take: "盘点" },
    status: {
      pending_putaway: "待上架", partially_putaway: "部分上架", putaway_completed: "上架完成",
      pending_pick: "待拣货", partially_picked: "部分拣货", picked_completed: "拣货完成",
      counting: "盘点中", completed: "已完成", unknown: "状态待确认",
    },
    empty: { mine: "当前没有我的待办", claimable: "当前没有可领取任务", completed: "当前没有已完成任务" },
  },
  auth: {
    loginTitle: "欢迎回来",
    loginLead: "企业负责人或受邀员工可使用邮箱或国际手机号登录。",
    entryNavigation: "登录帮助",
    identifier: "用户名、邮箱或手机号",
    password: "密码",
    login: "登录",
    forgot: "忘记密码？",
    inviteEntry: "收到邀请码？",
    applyEntry: "注册企业",
    inspectInvite: "核验邀请",
    inviteTitle: "接受员工邀请",
    inviteLead: "完成账号设置后，您将按邀请中的职责加入企业。",
    email: "邮箱",
    code: "8 位邀请码",
    name: "姓名",
    phone: "国际手机号",
    dialCode: "国际区号",
    dialCodePlaceholder: "请选择国际区号…",
    phoneNumber: "手机号码",
    phonePlaceholder: "请输入不含国际区号的手机号码…",
    phoneInvalid: "请输入有效的手机号码",
    inviteProfileConfirmed: "姓名和手机号已由邀请方确认，无需重复填写。",
    inviteProfilePartiallyConfirmed: "邀请中已确认的资料无需重复填写。",
    passwordHint: "使用 7–128 个字符，无需特定字符组合",
    showPassword: "显示{field}",
    hidePassword: "隐藏{field}",
    confirmPassword: "确认密码",
    passwordMismatch: "两次输入的密码不一致",
    agreementPrefix: "我已阅读并同意",
    privacy: "隐私政策",
    and: "和",
    terms: "服务条款",
    agreementError: "请先阅读并同意隐私政策和服务条款",
    currentAgreement: "当前生效协议",
    readingDone: "阅读完成",
    leaveWarning: "当前注册尚未完成，离开后填写内容将丢失。确定离开吗？",
    register: "完成注册",
    forgotTitle: "找回密码",
    forgotLead: "如果邮箱已验证，我们会发送一封重置邮件。",
    sendReset: "发送重置邮件",
    forgotAccepted: "请求已受理，请检查邮箱。",
    resetTitle: "设置新密码",
    resetLead: "重置链接一次性有效且有时效，使用后或过期需重新申请。",
    reset: "更新密码",
    resetDone: "密码已更新，请重新登录。",
    resetLinkInvalid: "链接无效或已过期",
    confirmEmailTitle: "确认登录邮箱",
    confirmEmail: "确认邮箱",
    confirmEmailDone: "邮箱已确认。",
    confirmEmailInvalid: "确认链接无效或已过期，请重新注册或返回登录。",
    registerAgain: "重新注册",
    expired: "登录状态已失效，请重新登录。",
    sessionUnavailableTitle: "暂时无法恢复登录状态",
    sessionUnavailableLead: "服务连接暂时不可用。你的登录状态尚未被清除，连接恢复后可继续使用。",
    sessionUnavailableRetry: "仍无法连接服务，请稍后重试。",
    restoreSession: "恢复并继续",
    captchaRequired: "请完成安全验证后重试。",
    invalidCredentials: "用户名、邮箱、手机号或密码不正确",
    securityCheck: "安全验证",
    captchaLead: "为保护账户，需要在本机完成一次轻量计算。",
    verifyCaptcha: "完成安全验证",
    captchaWorking: "正在验证…",
    captchaPassed: "安全验证已完成",
    captchaInvalid: "安全验证已失效，请重新完成。",
    captchaFailed: "安全验证未完成，请重试。",
    identityLabels: {
      customer: "客户",
      receivingStaff: "收货员",
      tenant_admin: "租户管理员",
      business_admin: "业务管理员",
      shipping: "发货",
      receiving: "收货",
    },
  },
  accountApplication: {
    title: "注册企业账号",
    lead: "验证负责人邮箱后立即创建企业，无需等待平台开户审核。",
    stepsLabel: "企业注册步骤",
    stepApplication: "1. 企业资料",
    stepReviewActivation: "2. 邮箱验证并创建",
    email: "邮箱",
    emailInvalid: "请输入有效邮箱",
    applicantName: "申请人姓名",
    organizationName: "企业名称",
    customerType: "客户类型",
    customerTypePlaceholder: "请选择客户类型",
    optionsLoading: "正在加载申请选项…",
    optionsUnavailable: "暂时无法加载申请选项，请稍后重试。",
    phone: "手机号码",
    phoneInvalid: "请输入有效的手机号码",
    dialCode: "国际区号",
    country: "国家 / 地区",
    countryPlaceholder: "请选择开放注册的国家 / 地区",
    countriesLoading: "正在加载开放国家…",
    countriesUnavailable: "暂时无法加载开放国家，请稍后重试。",
    note: "申请说明",
    submit: "发送邮箱验证码",
    accepted: "验证码已发送。",
    nextSteps: "验证邮箱并设置密码后，企业与唯一负责人将原子创建。",
    backToLogin: "返回登录",
    passwordSetupTitle: "验证邮箱并设置密码",
    passwordSetupLead:
      "开户申请已通过。打开此一次性凭据即验证你对邮箱的控制；请设置登录密码并同意当前协议，完成账户启用。",
    applyAgain: "重新申请开户",
  },
  home: {
    title: "企业工作台",
    greeting: "你好，{name}",
    lead: "今天的货物登记与到货进度，一眼就能看清。",
    declarations: "申报总数",
    pendingReceiving: "待收货",
    startDeclaration: "新建货物申报",
    registerCustomer: "查看企业资料",
    notices: "最新公告",
    customerFallback: "企业成员",
    quickLinksLabel: "快捷入口",
    notice: "货物送达前，请先确认企业资料、完成货物申报与付款凭证上传。",
    role: "企业业务",
    businessTitle: "业务办理",
    businessAside: "按收货流程排列",
    flowTitle: "收货流程",
    flowAside: "5 STEPS",
    nextEyebrow: "START HERE",
    nextRegisterTitle: "先确认企业资料",
    nextRegisterDescription: "负责人可维护资料，员工可只读查看。",
    nextRegisterTag: "第 1 步",
    nextDeclarationTitle: "提交第一份货物申报",
    nextDeclarationDescription: "填写商品与物流信息，生成申报单号。",
    nextDeclarationTag: "第 2 步",
    nextReceivingTitle: "查看待收货任务",
    nextReceivingDescription: "已有货物等待核验，可进入工作台继续处理。",
    nextReceivingTag: "待处理",
    nextTrackTitle: "跟进申报与付款状态",
    nextTrackDescription: "查看申报进度，需要时补充付款凭证。",
    nextTrackTag: "进行中",
    featureCustomer: "客户登记",
    featureCustomerEn: "Customer Reg.",
    featureDeclaration: "货物申报",
    featureDeclarationEn: "Goods Decl.",
    featurePayment: "付款登记",
    featurePaymentEn: "Payment Reg.",
    featureOrders: "我的申报",
    featureOrdersEn: "My Decl.",
    featureReceiving: "收货工作台",
    featureReceivingEn: "Receiving",
    featureContact: "联系我们",
    featureContactEn: "Contact Us",
    commonBusiness: "常用业务",
    declarationDescription: "新建申报单",
    customerDescription: "维护客户资料",
    paymentDescription: "上传付款凭证",
    primaryReceivingTitle: "扫码收货",
    primaryReceivingDescription: "扫码或查看待办",
    staffOnly: "工作人员入口",
    flowStep1: "客户登记资料，生成客户编号",
    flowStep2: "填写货物申报，生成申报单号与二维码",
    flowStep3: "付款并上传付款凭证，财务审核",
    flowStep4: "货物送达，工作人员扫码核验收货",
    flowStep5: "完成入库 / 选品登记，全程可查",
    receivingAddressLabel: "收货地址",
    receivingHoursLabel: "营业时间",
    noticeTag: "公告",
    receivingInfoTitle: "收货信息",
  },
  customer: {
    title: "客户登记",
    registerEyebrow: "客户资料",
    formSectionsLabel: "客户资料分类",
    basicTab: "基本信息",
    additionalTab: "补充资料",
    basicTitle: "客户与联系人",
    basicLead: "填写客户身份、业务联系人和常用所在地信息。",
    additionalTitle: "资质与补充信息",
    additionalLead: "非必填资料可稍后完善，已填写内容会随客户资料一并保存。",
    type: "客户类型",
    name: "公司或个人名称",
    contact: "联系人姓名",
    contactPhone: "业务联系电话",
    dialCode: "国际区号",
    phoneNumber: "电话号码",
    phoneInvalid: "请输入有效的电话号码",
    wechat: "微信号",
    country: "所在国家",
    countryPlaceholder: "请选择国家…",
    city: "所在城市",
    cityPlaceholder: "请选择城市…",
    selectCountryFirst: "请先选择国家…",
    whatsapp: "WhatsApp",
    license: "营业执照号",
    remark: "备注",
    certificates: "资质文件",
    certificatesHint: "支持图片、PDF、Word，最多 9 个；长按文件调整顺序",
    addCertificate: "添加资质文件",
    certificateSortHint: "长按拖动或使用方向键调整顺序",
    certificatePosition: "当前位置",
    saved: "客户资料已保存",
    update: "提交修改审核",
    pendingUpdateTitle: "资料修改审核中",
    pendingUpdateBody:
      "你提交的客户资料修改正在等待平台审核，审核通过后将自动生效。审核期间暂不能再次修改。",
    pendingUpdateMessage: "资料修改已提交，等待平台审核",
    pendingUpdateBlocked: "客户资料修改正在审核中，请等待审核结果后再提交",
  },
  declaration: {
    listTitle: "货物申报",
    createTitle: "货物申报",
    recordsEntry: "申报记录",
    shippingDraftNo: "发货单号",
    creatingServerDraft: "正在建立草稿…",
    serverDraftReady: "草稿已建立",
    retryCreateDraft: "重试建立草稿",
    addedItemsHeader: "已添加商品 {count}",
    stepDestination: "选择目的地",
    stepCustomer: "确认企业",
    stepGoods: "商品信息",
    stepLogistics: "物流与包装",
    stepWeighingReview: "磅单确认",
    stepTransport: "物流信息",
    stepConfirm: "确认提交",
    stepLogisticsReview: "物流与确认",
    logisticsPackageTitle: "物流公司与包装实测",
    logisticsPackageLead: "选择发货的快递/物流公司，填写运输信息，并按实际包装逐组录入单件尺寸、重量和件数。",
    logisticsCompanyLead: "选择承运本次发货的快递/物流公司；公司联系人的联系方式会自动带出。",
    logisticsCompanyEmptyBody:
      "请联系管理员前往“基础数据 → 业务选项 → 物流公司”，添加并启用至少一家快递/物流公司后再继续。",
    logisticsCompanyContact: "公司联系：{contact}",
    contextAutoNote: "收发货双方信息已按申报内容自动带出，无需重复填写。",
    transportDetails: "运输信息",
    packageGroupsTitle: "包装组",
    packageGroupsLead: "包装组独立于商品；同一包装可包含多个商品。",
    addPackageGroup: "添加包装组",
    packageGroup: "包装组 {index}",
    lengthCm: "长（cm）",
    widthCm: "宽（cm）",
    heightCm: "高（cm）",
    weightG: "单件重量（g）",
    previewWeighingTicket: "预览计价磅单",
    weighingReviewTitle: "电子磅单预览与确认",
    weighingReviewLead: "物流费用由服务端按费率卡计算；申报货值仅用于海关申报。",
    goodsValueSeparateNote: "申报货值与物流结算分开记录，未经汇率换算不会相加。",
    quotePendingTitle: "当前线路待配置报价",
    quoteUnavailable: "暂未取得可用物流报价。",
    quotePendingSubmitNote: "仍可提交申报，费率配置后可从申报详情重试。",
    freightSettlement: "物流结算",
    payFreightOnline: "支付物流费用",
    continueFreightPayment: "继续支付",
    retryQuote: "重新获取报价",
    refundProgress: "退款单 {no} · {status}",
    settlementStatus: {
      unquoted: "待报价",
      estimated_due: "待预付",
      payment_pending: "支付确认中",
      prepaid: "已预付",
      reconciling: "收货复核中",
      adjustment_due: "待补差",
      refund_pending: "退款处理中",
      settled: "已结清",
      exception: "结算异常",
    },
    destination: "目的地",
    destinationTitle: "这批货物要送到哪里？",
    destinationLead:
      "请选择本次申报对应的收货中心，后续商品和物流信息都将归入该目的地。",
    selected: "已选",
    destinationEmptyTitle: "暂未配置可用目的地",
    destinationEmptyBody:
      "请联系管理员前往“基础数据 → 业务选项 → 申报目的地”，添加并启用至少一个目的地后再新建申报。",
    customerConfirmTitle: "确认收货客户信息",
    customerConfirmLead:
      "本次申报将使用已登记的客户主体；请确认联系人和电话无误。",
    confirmed: "已确认",
    contactIncomplete: "联系人信息待完善",
    completeContact: "完善企业联系信息",
    coordinatePairRequired: "请同时填写纬度和经度",
    coordinateInvalid: "请输入有效的经纬度",
    customerMissingTitle: "尚未登记客户资料",
    customerMissingBody: "请先完成客户资料登记，再继续填写货物申报。",
    registerCustomer: "前往登记客户资料",
    imagesRequired: "请至少上传一张商品图片",
    imagesTooMany: "商品图片最多 3 张",
    vouchersTooMany: "申报凭证最多 9 张",
    imageHint: "最多 9 张；可拍商品、包装、标签和装箱情况。",
    addAtLeastOneItem: "请先保存至少一件商品",
    itemSaved: "第 {count} 件商品已保存，可继续添加下一件",
    editCurrentItem: "编辑当前商品",
    addCurrentItem: "逐条添加商品",
    itemEditorLead:
      "当前页面只录入一件商品；保存后表单会清空，已保存商品请到独立管理页查看。",
    existingImages: "已保留 {count} 张历史图片",
    historyPickerConfirmSingle: "使用此商品",
    logisticsAndReviewTitle: "物流信息与确认提交",
    logisticsAndReviewLead: "补充本次运输信息，核对汇总后再正式提交申报。",
    savedGoodsCount: "已保存 {count} 件商品",
    savedItemsShort: "已保存 {count} 件",
    manageItems: "管理商品",
    saveItemChanges: "保存修改",
    addAnotherItem: "新增商品",
    saveDeclaration: "保存申报",
    manageItemsTitle: "草稿商品管理",
    manageItemsLead: "在独立页面管理本申报单中的全部商品。所有改动仅更新草稿。",
    newItem: "新增商品",
    saveItem: "保存商品",
    itemActions: "商品操作",
    itemQuantitySummary: "{quantity} {unit} · {boxes} 箱",
    itemPackagingSummary: "{packaging} · {packages} 包装件 · {quantity} {unit}",
    emptyDraftItems: "草稿中还没有商品",
    continueDeclaration: "继续填报",
    deleteDraft: "删除草稿",
    deleteDraftTitle: "删除这个草稿？",
    deleteDraftBody: "{no} 尚未建立为正式单据。删除后无法恢复；系统会保留本次删除操作的审计记录。",
    confirmDeleteDraft: "确认删除",
    deleteItemTitle: "删除商品？",
    deleteItemBody:
      "“{name}”将从当前草稿移除。删除最后一件商品后仍可保存草稿，但不能提交。",
    recordsTitle: "申报记录",
    recordsCount: "共 {count} 份申报",
    newDeclaration: "新申报",
    recordFilters: "申报记录筛选",
    filterDraft: "草稿",
    draftRecord: "草稿申报",
    declarationNo: "申报单号",
    destinationNotRecorded: "未记录目的地",
    moreItems: "另有 {count} 件商品",
    recordTotals: "{quantity} 件商品 · {boxes} 包装件",
    recordMetricKinds: "商品种类",
    recordMetricPackages: "包装件数",
    recordMetricAmount: "申报金额",
    recordKindsValue: "{count} 种商品",
    recordPackagesValue: "{count} 包装件",
    viewDetail: "查看详情",
    pullToRefresh: "下拉刷新",
    releaseToRefresh: "松手刷新",
    refreshing: "正在刷新",
    refreshed: "刷新完成",
    noRecordsInFilter: "当前筛选下暂无申报记录",
    identityHint: "申报主体",
    goodsHint: "商品明细",
    confirmLead: "请核对申报主体、商品和物流信息，确认无误后提交。",
    goodsSummary: "商品汇总",
    logisticsSummary: "物流汇总",
    totalItems: "商品总数量",
    totalBoxes: "合计箱数",
    totalPackages: "合计包装件数",
    unset: "未填写",
    purpose: "货物用途",
    customerName: "客户名称",
    customerNamePlaceholder: "与登记资料一致的公司或个人名称",
    contactName: "联系人",
    phone: "联系电话",
    phonePlaceholder: "请输入含国家区号的联系电话",
    goodsName: "商品名称",
    goodsNamePlaceholder: "例如 LED 台灯",
    category: "商品品类",
    specification: "规格",
    quantity: "数量",
    quantityRuleInvalid: "请检查数量与包装计算是否一致",
    quantityPrecisionInvalid:
      "数量格式不正确；该单位最多允许 {precision} 位小数，0 位表示只能输入整数。",
    currencyUnset: "未选择币种",
    unit: "单位",
    boxes: "箱数",
    unitPrice: "单价",
    unitPriceWithCurrency: "单价（{currency}）",
    unitPricePrecisionInvalid:
      "请输入非负金额，且小数位不超过 {precision} 位。",
    quantityAndPackaging: "数量与包装",
    packagingType: "包装方式",
    quantityMode: "数量填写方式",
    quantityModeCalculated: "按包装计算",
    quantityModeManual: "直接填写数量",
    packageCount: "包装件数",
    quantityPerPackageWithUnit: "每件数量（{unit}）",
    looseQuantityWithUnit: "散装数量（{unit}）",
    manualQuantityWithUnit: "商品总数量（{unit}）",
    packagingNote: "包装说明",
    packagingNotePlaceholder: "请说明实际包装方式",
    calculationReceipt: "自动计算",
    quantityFormulaLabel: "数量公式",
    packagingFormula:
      "{packages} × {perPackage} {unit} + {loose} {unit} = {quantity} {unit}",
    manualQuantityFormula: "直接填写 {quantity} {unit} = {quantity} {unit}",
    totalQuantity: "总数量",
    itemTotalPrice: "商品总价",
    unitFallback: "单位",
    packagingCarton: "纸箱",
    packagingWoodenCase: "木箱",
    packagingPlasticCrate: "塑料周转箱",
    packagingBag: "袋",
    packagingBale: "包/捆",
    packagingPallet: "托盘",
    packagingDrum: "桶",
    packagingLoose: "散装/无包装",
    packagingOther: "其他",
    images: "商品图片（选填）",
    addGoodsImage: "添加商品图片",
    goodsImageLimitHint: "最多添加 3 张，可拍摄商品外观、标签或型号。",
    goodsRemark: "商品备注",
    goodsRemarkPlaceholder: "选填，例如易碎、颜色或收货时需注意的事项…",
    goodsImageHint:
      "仅用于识别商品本身，可拍摄外观、标签或型号；不上传也可继续。",
    declarationVouchers: "申报凭证（选填）",
    addVoucherFromAlbum: "从相册上传",
    takeVoucherPhoto: "拍照上传",
    voucherSortHint: "长按拖动或使用方向键调整顺序",
    voucherPosition: "当前位置",
    declarationVoucherHint:
      "可上传发票、采购单、价格截图等申报依据，与商品图片分开保存。",
    existingVouchers: "已保留 {count} 张申报凭证",
    itemSectionsLabel: "商品信息填写步骤",
    itemTabCategory: "商品分类",
    itemTabInfo: "商品信息",
    itemTabPackaging: "数量与包装",
    // Keep the compact tab label separate from the longer optional field label.
    itemTabVouchers: "申报凭证",
    itemBasicLead: "先确认商品是什么；商品图片用于识别商品本身，可选填。",
    itemPackagingLead: "填写包装方式和数量，系统会自动核算商品总量与总价。",
    itemVouchersLead: "申报凭证用于说明价格或采购来源，可稍后补充。",
    categoryQuickLead: "选择最接近的商品分类，选中后将自动进入商品信息。",
    categoryEmpty: "暂无可选商品分类",
    chooseCategoryFirst: "请先在“商品分类”中选择品类。",
    imageCount: "{count} 张",
    addItem: "添加商品",
    removeItem: "删除此项",
    removeItemNamed: "删除第 {index} 项商品",
    pickFromHistory: "从历史选品",
    historyPickerTitle: "从历史商品中选择",
    historyPickerSearch: "搜索商品名称 / 品牌 / 条码",
    historyPickerConfirm: "加入商品明细",
    historyPickerEmpty: "暂无历史商品",
    uncategorized: "未分类",
    expectedArrival: "预计到货日期",
    shippingOrigin: "发货地",
    logisticsCompany: "物流公司",
    trackingNo: "物流单号",
    trackingNoPlaceholder: "例如 SF1234567890",
    vehicleDriver: "车牌及司机",
    manager: "收货负责人",
    managerAssignedHint: "收货负责人由管理端统一指派，无需客户选择",
    transportRemark: "运输备注",
    submit: "提交申报",
    submitted: "申报已提交",
    detailTitle: "申报详情",
    declarationInfoTitle: "申报信息",
    attachmentOpenFailed: "附件打开失败",
    supplement: "补充资料",
    continueEdit: "继续编辑",
    qrFailed: "二维码生成失败，请出示单号收货",
    copyNo: "一键复制单号",
    copied: "单号已复制",
    copyFallback: "已为你选中单号，请手动复制",
    pay: "登记付款",
    stepsLabel: "申报步骤",
    filterPendingPayment: "待付款",
    filterPendingReceiving: "待收货",
    filterArrived: "已到货",
    filterAbnormal: "异常",
    goodsSeparator: "、",
    metaBoxes: "📦 {count} 包装件",
    metaExpected: "📅 预计 {date}",
    metaSubmitted: "提交 {date}",
    costsTitle: "费用与结算",
    goodsAmount: "商品金额",
    serviceFee: "服务费",
    freight: "运费",
    totalPayable: "应付总额",
    approvedReceived: "已确认到账",
    refunded: "已退款",
    logisticsTitle: "物流与到货",
    routeLabel: "运输路线",
    receivingRecords: "收货记录",
    boxesAndItems: "{boxes} 包装件 / {quantity} 件商品",
    pendingFollowUp: "待后续处理",
    noReceivingRecords: "暂无收货记录",
    timelineTitle: "业务时间线",
    noTimelineEvents: "暂无业务动态",
    qrCodeLabel: "申报单二维码",
    statusPanelLabel: "业务状态",
    statusDeclaration: "申报",
    statusPayment: "付款",
    statusReceiving: "收货",
    shipmentTitle: "物流轨迹",
    waybillNo: "运单号",
    carrier: "承运商",
    currentStatus: "当前状态",
    noTrackEvents: "暂无轨迹事件",
    trackStatus: {
      pending: "待揽收",
      picked_up: "已揽收",
      in_transit: "运输中",
      customs_hold: "清关中",
      delivered: "已送达",
      exception: "异常",
      departed: "已发车",
      arrived: "已到达",
      out_for_delivery: "派送中",
    },
    wizardAssigned: "提交后由管理员指派",
    itemsTitle: "商品明细",
    itemsSummary: "{kinds} 种商品 · {packages} 包装件 · 共 {quantity}",
    domainsLabel: "申报单信息域",
    tabGoods: "商品",
    tabLogistics: "物流",
    tabReceiving: "收货",
    tabRecords: "档案",
    archivedBadge: "已建档",
    noImage: "未上传商品图片",
    voucherCount: "凭证 {count} 张",
    voucherTitle: "申报凭证",
    packagesUnit: "包装件",
    spec: "规格",
    noItems: "暂无商品明细",
    draftSaved: "草稿已保存到服务器，可在其他设备继续编辑。",
    editTitle: "补充或编辑申报资料",
    saveServerDraft: "保存服务器草稿",
  },
  payment: {
    freightWeighingTicket: "透明计价磅单",
    actualWeight: "实重",
    volumetricWeight: "体积重",
    chargeableWeight: "计费重",
    freightPayable: "物流应付",
    freightFormulaNote: "每件取实重与体积重较大值，按费率卡进位后汇总",
    onlineCheckoutTitle: "物流费用在线支付",
    onlineCheckoutLead: "请核对计价磅单并选择可用支付渠道。支付结果以后端异步确认为准。",
    onlineStatusTitle: "在线支付状态",
    chooseOnlineChannel: "选择支付渠道",
    mpesaPhone: "M-PESA 手机号",
    mpesaPhoneHint: "系统将向该号码发起 STK Push，请在手机上确认。",
    noOnlineChannel: "当前币种暂无在线支付渠道",
    offlineAuthorizationOnly: "只有后台按本申报明确开启线下付款后，才能使用受控兜底。",
    requestMpesa: "发送 M-PESA 授权请求",
    openWechatPay: "前往微信支付",
    onlineCreateFailed: "在线支付订单创建失败，请稍后重试。",
    onlinePaidTitle: "物流费用已支付",
    onlinePaidLead: "提供商回调已确认到账，可返回申报查看后续进度。",
    onlinePendingTitle: "等待支付确认",
    mpesaPendingLead: "请在手机上完成 M-PESA 授权；页面会自动刷新状态。",
    wechatPendingLead: "若已完成微信支付，请保留此页等待后台确认。",
    onlineFailedTitle: "本次支付未完成",
    onlineFailedLead: "没有确认扣款。可返回收银台重新发起支付。",
    retryOnlinePayment: "重新发起支付",
    viewDeclaration: "查看申报详情",
    pollingProvider: "正在等待支付提供商确认…",
    title: "付款登记",
    lead: "上传付款依据并关联申报单；提交结果以后端确认为准。",
    listTitle: "我的付款",
    detailTitle: "付款详情",
    declaration: "关联申报单",
    loadingDeclaration: "正在加载申报单…",
    chooseDeclaration: "请选择申报单",
    payer: "付款人名称",
    amount: "付款金额",
    currency: "币种",
    method: "付款方式",
    date: "付款日期",
    transaction: "银行或 M-Pesa 流水号",
    transactionNo: "流水号",
    account: "付款账户",
    actualReceived: "实收金额",
    receivedAccount: "收款账户",
    reviewResult: "审核结果",
    reviewedAt: "审核时间",
    financeRemark: "财务备注",
    vouchers: "付款凭证",
    vouchersRequired: "请上传至少一张付款凭证。",
    note: "备注",
    submit: "提交付款登记",
    submitted: "付款登记已提交",
    refundsTitle: "退款记录",
    noRefunds: "暂无退款",
    bankTransfer: "银行转账",
    rulesTitle: "收款与审核说明",
    bankAccount: "银行账户",
    serviceChargeRule: "收费说明",
    paymentRules: "审核规则",
    payerAccount: "付款账户或 M-Pesa 号码",
    cash: "现金",
    recordsEntry: "付款记录",
    stepsLabel: "付款登记步骤",
    stepDeclaration: "选择申报",
    stepDetails: "付款信息",
    chooseTitle: "选择本次付款对应的申报",
    chooseLead: "仅展示当前仍可登记付款的申报单，选择后将自动计算剩余应付。",
    noPayableDeclarations: "暂无可付款申报，请先完成货物申报或查看申报状态。",
    viewDeclarations: "查看申报记录",
    totalPayable: "总应付",
    activeRegistered: "审核中 / 已到账",
    remainingPayable: "剩余应付",
    balanceTicket: "申报付款余额",
    linkedDeclaration: "关联申报",
    detailsTitle: "填写付款信息",
    detailsLead: "请按实际交易填写，并上传清晰、完整的付款凭证。",
    changeDeclaration: "更换申报",
    changeDeclarationWarning: "更换申报将清空当前付款信息，是否继续？",
    payerAndAmount: "付款人与金额",
    contactPhone: "联系电话",
    currencyLocked: "币种与申报单保持一致",
    chooseMethod: "请选择付款方式",
    transactionEvidence: "交易依据",
    bankTransactionNo: "银行流水号",
    bankPayerAccount: "付款账户",
    mpesaTransactionNo: "M-Pesa 交易号",
    mpesaNumber: "M-Pesa 号码",
    digitalTransactionNo: "支付交易号",
    digitalPayerAccount: "付款账号",
    posTransactionNo: "POS 流水号",
    cardLastFour: "卡号后四位",
    cashReceiptNo: "收据编号",
    genericTransactionNo: "付款凭据编号",
    accountDescription: "账户说明（可选）",
    voucherLead: "支持图片或 PDF；提交前可继续补充或移除文件。",
    addVoucher: "添加付款凭证",
    amountPositive: "付款金额必须大于 0。",
    amountWholeUnit: "付款金额需填写整数。",
    amountExceedsRemaining: "付款金额不能高于剩余应付。",
    cardLastFourInvalid: "请输入 4 位卡号末尾数字。",
    reviewAndSubmit: "核对并提交",
    confirmTitle: "核对付款登记",
    confirmLead: "确认信息与付款凭证一致后再提交，提交后将进入审核。",
    voucherCount: "{count} 份凭证",
    backToEdit: "返回修改",
    confirmSubmit: "确认提交",
    recordsTitle: "付款记录",
    recordsCount: "共 {count} 条付款登记",
    newPayment: "新登记",
    recordFilters: "付款记录筛选",
    filterPendingReview: "待审核",
    filterPaid: "已付款",
    filterUnsuccessful: "未通过",
    searchPlaceholder: "搜索付款号、申报单号、流水号或付款人",
    pullToRefresh: "下拉刷新",
    releaseToRefresh: "松开刷新",
    refreshing: "正在刷新",
    refreshed: "刷新完成",
    noRecordsInFilter: "当前筛选条件下没有付款记录",
    viewDetail: "查看详情",
    paymentNo: "付款编号",
    createdAt: "登记时间",
    paymentInfoTitle: "付款信息",
    reviewInfoTitle: "审核结果",
    voucherFilesTitle: "付款凭证",
    voucherUploaded: "已上传",
    openVoucher: "打开凭证",
    noVouchers: "暂无付款凭证",
    attachmentOpenFailed: "付款凭证暂时无法打开，请稍后重试。",
    continuePayment: "继续付款",
    retryPayment: "重新登记",
  },
  message: {
    inboxTitle: "消息中心",
    detailTitle: "消息详情",
    markAllRead: "全部已读",
    markAllDone: "已全部标记为已读",
    unread: "未读",
    empty: "暂无消息",
    emptyBody: "该消息没有正文内容",
    openAction: "查看详情",
    featureEntry: "消息",
    featureEntryEn: "INBOX",
  },
  receiving: {
    title: "收货工作台",
    heroAccount: "收货工作台 · {name}",
    lead: "查找分配给我的待收货申报，扫码、图片和手工编号均可查询。",
    manager: "收货负责人",
    query: "申报单号、物流单号、客户名称或电话",
    scan: "扫描二维码",
    image: "识别二维码图片",
    manual: "手工输入编号",
    find: "查询任务",
    verifyTitle: "收货核验",
    compareTitle: "客户申报数据（请逐项核对）",
    compareCustomer: "客户：{name} ｜ 电话：{phone}",
    compareItem: "{name}：{quantity} {unit} / {boxes} 包装件",
    compareTotal: "合计包装件数：{boxes} ｜ 物流：{logistics}",
    itemizedTitle: "逐商品实收",
    itemizedLead:
      "按本次实际收到的商品填写，累计超出申报数量时服务器将拒绝提交。",
    declaredLine: "申报：{boxes} 包装件 / {quantity} {unit}",
    boxesVsQuantity: "{boxes} 包装件 / {quantity} {unit}",
    boxesOnly: "{boxes} 包装件",
    actualBoxes: "实际包装件数",
    actualQuantity: "实收数量",
    actualWeight: "实际重量（克）",
    actualVolume: "实际体积（立方厘米）",
    condition: "包装与申报核验结果",
    warehouse: "入库仓位",
    abnormalType: "异常类型",
    abnormalDescription: "异常说明",
    photos: "收货照片",
    receiverName: "收货人姓名",
    submit: "确认收货结果",
    submitted: "收货结果已提交",
    scanDeclaration: "识别申报二维码",
    scanLead: "扫描现场二维码，或选择已有图片。",
    searchPlaceholder: "输入申报单号 / 物流单号 / 客户名称 / 电话…",
    searchSubmit: "查询",
    heroStats: "我名下待处理 {pending} 单 · 已闭环 {completed} 单",
    scanPrimaryTitle: "扫码收货",
    scanPrimaryLead: "识别申报二维码，快速打开核验任务",
    pendingLabel: "待收货",
    completedLabel: "已完成",
    scanMethodTitle: "选择识别方式",
    scannerTicketTitle: "扫码票据台",
    scanActionLead: "扫描现场二维码，快速打开核验任务",
    imageActionLead: "从相册选择已有二维码图片",
    scanAutoOpenHint: "识别申报二维码后自动进入核验",
    lookupNoExactMatch: "未找到与该二维码完全匹配的收货单，请改用顶部查询。",
    lookupFailed: "暂时无法查询二维码对应的收货单，请重试。",
    ordersTitle: "收货单",
    ordersLead: "查询并处理分配给我的收货任务",
    statsUnavailable: "数量暂时不可用",
    tasksTitle: "待收货任务",
    tasksLead: "仅显示明确指派给我的任务",
    completedEntry: "收货记录",
    managerLine: "负责人：{name}",
    packagesLine: "{count} 包装件",
    managerUnset: "待分配",
    empty: "暂无待收货任务",
    completedTitle: "已收货物",
    completedDetailTitle: "已收货物详情",
    completedEmpty: "暂无已收货记录",
    completedAt: "完成时间",
    readOnlyNotice: "该收货任务已闭环，以下记录仅供查看。",
    receivedBoxes: "实收 {count} 包装件",
    recordNumber: "收货编号",
    receivedSummary: "{boxes} 包装件 / {quantity} 件商品",
    itemReceivedLine: "{boxes} 包装件 / {quantity} {unit}",
    weightValue: "{value} 克",
    volumeValue: "{value} 立方厘米",
    matched: "与申报一致",
    damaged: "包装破损",
    shortage: "数量短缺",
    none: "无异常",
    other: "其他异常",
  },
  profile: {
    title: "个人中心",
    account: "账户信息",
    verified: "已验证",
    unverified: "未验证",
    pendingEmail: "待确认邮箱",
    changeEmail: "更换登录邮箱",
    newEmail: "新的登录邮箱",
    currentPassword: "当前密码",
    sendConfirmation: "发送确认邮件",
    sent: "确认邮件已发送。",
    language: "语言",
    identity: "当前身份",
    identityDual: "客户 + 收货员",
    identityStaffInvite: "收货员（邀请制）",
    inviteOnly: "邀请制",
    accountSettings: "账户设置",
    preferences: "偏好设置",
    unnamed: "未设置姓名",
    avatar: "头像",
    changeAvatar: "更换头像",
    editAvatar: "编辑头像",
    avatarUpdated: "头像已更新",
    avatarInvalidType: "请选择图片文件",
    avatarTooLarge: "图片大小不能超过 2MB",
    avatarPreview: "头像预览",
    avatarHint: "点击上方圆形区域选择图片",
    avatarSelect: "选择图片",
    avatarReselect: "重新选择",
    avatarConfirm: "确认使用",
    avatarRemove: "移除头像",
    avatarDiscard: "放弃修改",
    avatarRemoveConfirmTitle: "确认移除头像",
    avatarRemoveConfirmBody: "移除后将恢复为默认头像。确定继续吗？",
    avatarRemoveConfirm: "确认移除",
  },
  legal: {
    privacyTitle: "隐私政策",
    privacyBody:
      "我们仅处理完成账户认证、客户登记、货物申报、付款登记和到货核验所必需的信息。登录凭据、一次性链接和业务附件按照最小权限原则保存与访问。",
    termsTitle: "服务条款",
    termsBody:
      "使用本终端即表示你会提供真实、完整的业务信息，并妥善保管账户。关键提交以后端确认结果为准；发现异常时请及时联系运营人员。",
    version: "版本",
    currentEffective: "当前生效",
    notConfigured: "当前协议尚未配置，请联系管理员后再开户。",
    loadingRetry: "正在加载当前协议，请稍后重试。",
  },
  errors: {
    firstInvalid: "请修正标记的字段后继续。",
    inviteInvalid: "邀请无效、已使用、已撤销或已过期。",
    scanFailed: "未识别到有效编号，请改用图片或手工查询。",
    unknownStatus: "未知状态",
    notFound: "没有找到这个页面",
  },
};
